import * as React from 'react';
import { Box } from '../../designSystem/components/box';
import { Flex } from '../../designSystem/components/flex';
import { PsuiUserPlanningFragment } from '../../generated/types';
import { IntervalService } from '../../services/intervalService';
import { getColorPalette } from '../../util/color';
import { useService, useTranslate } from '../../util/dependencies/dependencies';
import { fullName } from '../../vo/positionSlot';

interface IUserPlanningPositionProps {
    psui: PsuiUserPlanningFragment;
    startHour?: number;
}

export const UserPlanningPosition = (props: IUserPlanningPositionProps) => {
    const translate = useTranslate();
    const intervalService = useService(IntervalService);
    const colorCss = React.useMemo(() => {
        const palette = getColorPalette(props.psui.position.color);

        return {
            background: palette['50'],
            color: palette['700']
        };
    }, [props.psui]);
    const shouldOffsetStartHour = React.useMemo(
        () =>
            typeof props.startHour === 'number' &&
            props.startHour > 0 &&
            props.psui.positionSlot.range.start!.hour < props.startHour,
        [props.psui, props.startHour]
    );
    const slotName = React.useMemo(() => {
        const name = fullName(intervalService, props.psui.positionSlot, '', {
            interval: {
                options: { hideDate: true }
            },
            slot: { includeRange: true }
        });

        return shouldOffsetStartHour ? `${name} ${translate('j_1_51317')}` : name;
    }, [props.psui, shouldOffsetStartHour]);

    return (
        <Flex
            css={{
                ...colorCss,
                borderRadius: '$1',
                padding: '$1 $2'
            }}
            direction="column"
            gap="1"
            justify="center"
            width={1}
        >
            <Box css={{ fontSize: '10px' }}>{slotName}</Box>

            <Box fontSize="textXs" fontWeight="medium">
                {props.psui.position.name}
            </Box>
        </Flex>
    );
};
